// Defaults
import "./scripts/ComponentManager";
import '../src/Layout/Subpage';
import Global from "./scripts/Global";
import LazyAsset from '../src/Components/LazyAsset/LazyAsset.js';

if( typeof window.theme == 'undefined' ) {
    window.theme = {};
}
window.theme.methods = new Global();

window.theme.lazyObj = new LazyAsset();
window.theme.lazyObj.init();